import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

const THRESHOLD = 600;

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Hide on admin to avoid covering the live-preview controls.
  if (pathname.startsWith("/admin")) return null;

  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={handleClick}
          initial={{ opacity: 0, y: 12, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.9 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
          aria-label="Back to top"
          title="Back to top"
          data-testid="back-to-top-button"
          className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-40 h-12 w-12 sm:h-14 sm:w-14 grid place-items-center bg-brand text-white border border-brand-light/40 shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:bg-brand-light hover:scale-105 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-light focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        >
          <ArrowUp className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2.4} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
